/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import ConfirmModalBtn from './ConfirmModalBtn'
import DeleteBtn from './DeleteBtn'
import ExportExcelButton from './ExportExcelButton'
import ProFormSelectSearch from './ProFormSelectSearch'
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown'
import SelectSearch from './SelectSearch'
import { TableModalForm } from './TableModalForm'

export {
  AvatarDropdown,
  AvatarName,
  ConfirmModalBtn,
  DeleteBtn,
  ExportExcelButton,
  ProFormSelectSearch,
  SelectSearch,
  TableModalForm,
}
